import {
  LogicalOperatorEnumerator,
  LogicalOperatorTypes,
} from "../Elements/FilterSelect/LogicalOperatorsOptions";

import moment from "moment";
import { DATE_QB_FORMAT } from "../Elements/FilterSelect/LogicalOperatorInBetweenDate";

/**
 * Returns a druid filter for the In The Last period event
 * @param {*} filter
 * @param {*} lo
 */
const setInTheLast = (filter, lo) => ({
  type: LogicalOperatorTypes.bound,
  dimension: filter.dimension,
  lower: moment(lo.value.calculatedDate).format(DATE_QB_FORMAT),
  lowerStrict: true,
});

/**
 * Returns a druid filter for Before the Last period event
 * @param {*} filter
 * @param {*} lo
 */
const setBeforeTheLast = (filter, lo) => ({
  type: LogicalOperatorTypes.bound,
  dimension: filter.dimension,
  upper: moment(lo.value.calculatedDate).format(DATE_QB_FORMAT),
  upperStrict: true,
});

/**
 * Returns a druid filter for In Between period event
 * @param {*} filter
 * @param {*} lo
 */
const setInBetween = (filter, lo) => ({
  type: LogicalOperatorTypes.bound,
  dimension: filter.dimension,
  upper: moment(lo.value.endDateValid).format(DATE_QB_FORMAT),
  lower: moment(lo.value.startDateValid).format(DATE_QB_FORMAT),
  lowerStrict: false,
  upperStrict: false,
});

/**
 * Return a druid filter for On period event
 * @param {*} filter
 * @param {*} lo
 */
const setOn = (filter, lo) => ({
  type: LogicalOperatorTypes.bound,
  dimension: filter.dimension,
  // the date must be the same
  upperStrict: true,
  upper: moment(lo.value.startDate).add(1, "day").format(DATE_QB_FORMAT),
  lower: moment(lo.value.startDate).add(-1, "day").format(DATE_QB_FORMAT),
  lowerStrict: true,
});

// Map func calc for each Logical Operator related to Dates
const loMapFuncSet = {
  [LogicalOperatorEnumerator.InTheLast]: setInTheLast,
  [LogicalOperatorEnumerator.BeforeTheLast]: setBeforeTheLast,
  [LogicalOperatorEnumerator.InBetween]: setInBetween,
  [LogicalOperatorEnumerator.NotInBetween]: setInBetween,
  [LogicalOperatorEnumerator.On]: setOn,
  [LogicalOperatorEnumerator.NotOn]: setOn,
};

/**
 * Return the druid filter creators according the logical operator
 * @param {*} filterProps
 * @param {*} logicalOperator
 */
const QueryFilterDates = (filterProps, logicalOperator) => {
  return loMapFuncSet[logicalOperator.description](
    filterProps,
    logicalOperator
  );
};

export default QueryFilterDates;
